import React from "react";

const ImageWithText = (props) => {
  const handleList = () => {
    let list = props.data.map((e) => e.name + " ");
    alert(`Ma liste (${props.data.length}) : ${list}`);
  };
  return (
    <div
      className="text-center mr-5 d-none d-sm-block"
      style={{ position: "relative" }}
    >
      <img src={props.imgSrc} alt={props.imgAlt} style={{ height: "50px" }} />
      <div
        className="text-warning font-weight-bold"
        style={{
          position: "absolute",
          top: "75%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        onClick={handleList}
      >
        {props.text}
      </div>
    </div>
  );
};

export default ImageWithText;
